if (!customElements.get('free-shipping')) {
    class FreeShipping extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.updateBar();
        }

        updateBar() {
            const total = parseInt(this.dataset.cartTotal, 10) || 0;
            const firstThreshold = parseInt(this.getAttribute('data-first-threshold'), 10) || 0;
            const secondThreshold = parseInt(this.getAttribute('data-second-threshold'), 10) || 0;
            const fill = this.querySelector('.progress-fill');
            
            if (!fill) return;

            let exactPercentage = 0;

            if (total > 0) {
                if (total < firstThreshold) {
                    exactPercentage = (total / firstThreshold) * 50;
                } else if (total >= firstThreshold && total < secondThreshold) {
                    const range = secondThreshold - firstThreshold;
                    const progressInRange = total - firstThreshold;
                    exactPercentage = 50 + (progressInRange / range) * 50;
                } else if (total >= secondThreshold) {
                    exactPercentage = 100;
                }
            }

            let steppedPercentage = Math.floor(exactPercentage / 10) * 10;

            if (total >= firstThreshold && steppedPercentage < 50) {
                steppedPercentage = 50;
            }
            
            if (total >= secondThreshold) {
                steppedPercentage = 100;
            }

            fill.style.width = `${steppedPercentage}%`;
            
            this.style.setProperty('--percentage', steppedPercentage / 100);

            this.querySelectorAll('.progress-icon').forEach((icon, index) => {
                const threshold = (index === 0) ? firstThreshold : secondThreshold;
                icon.classList.toggle('active', total >= threshold);
            });
        }
    }
    customElements.define('free-shipping', FreeShipping);
}